import { brandEntityId, BrandEntityId, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandDeleteRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandDeleteRequest) {
    JsonSchemaValidator.assert(RoomBrandDeleteRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId"],
      properties: {
        roomId,
        brandId: brandEntityId
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandDeleteRequest {
  roomId: RoomId;
  brandId: BrandEntityId;
}
